import { Modal } from 'antd';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { AxiosInterceptor } from './api';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    Modal.destroyAll();
  }, [location.pathname]);

  return (
    <>
      <AxiosInterceptor />
      <Outlet />
    </>
  );
}
